import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../utils/Encrypt";
import { hasPermission } from "../../../utils/myFunctions";
import Content from "../../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Row } from "../../../components/Component";
import Head from "../../../layout/head/Head";
import { getLMSDashboardDataAPI } from "../../../api/LMS/lmsdashboard";
import { useForm } from "react-hook-form";
import useLogout from "../../../utils/Utils";
import { toast } from "react-toastify";
import icon from "../../../assets/images/icons/icon-park-outline_school.svg";
import { BASE_URL_IMG_LMS } from "../../../assets/constants/constants";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      cardData: null,
      isLoading: true,
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const logout = useLogout();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);

  useEffect(() => {
    getDashboardData();
  }, []);
  const getDashboardData = () => {
    // API call here
    setValue("isLoading", true);
    getLMSDashboardDataAPI({})
      .then((res) => {
        console.log(res, "dashboard data");
        const status = res?.data?.status;
        if (status == "expired") {
          toast.error(res.data.message);
          logout();
        } else if (status) {
          setValue("cardData", res?.data?.data?.cardData || []);
          setValue("isLoading", false);
        } else if (!status) {
          setValue("isLoading", false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <Head title="Dashboard" />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={"sm"}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    Dashboard
                  </BlockTitle>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className="g-gs">
                {watch("cardData") && watch("cardData").length > 0 ? (
                  <>
                    {watch("cardData").map((item, index) => (
                      <div key={index} className="col-xxl-4 col-sm-6 mb-2">
                        <div
                          className="card"
                          style={{
                            borderLeft: `5px solid ${item?.color}`,
                            borderRadius: "8px",
                            cursor: `${item.count == 0 ? "none" : "pointer"}`,
                          }}
                        >
                          <div className="nk-cmwg nk-cmwg1">
                            <Link
                              to={`${item.count == 0 ? "#" : item?.slug}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                cursor: `${item.count == 0 ? "default" : "pointer"}`,
                              }}
                            >
                              <div className="card-inner pt-3">
                                <div className="d-flex justify-content-between">
                                  <div className="flex-item">
                                    <h4 className="" style={{ fontSize: "18px" }}>
                                      {item.title}
                                    </h4>
                                    <h6 className="" style={{ fontSize: "16px" }}>
                                      {item.count || 0}
                                    </h6>
                                  </div>
                                  <div>
                                    <img src={BASE_URL_IMG_LMS + item?.icon} alt="icon" width={45} />
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {[...Array(6)].map((_, index) => (
                      <div key={index} className="col-xxl-3 col-sm-6 mb-2">
                        <div className="card" style={{ backgroundColor: "#e0e0e0", cursor: "wait" }}>
                          <div className="nk-cmwg nk-cmwg1">
                            <div className="card-inner pt-3">
                              <div className="d-flex justify-content-between">
                                <div className="flex-item">
                                  <div
                                    className="skeleton-title"
                                    style={{
                                      width: "70%",
                                      height: "20px",
                                      backgroundColor: "#ccc",
                                      marginBottom: "10px",
                                    }}
                                  ></div>
                                  <div
                                    className="skeleton-count"
                                    style={{ width: "40%", height: "16px", backgroundColor: "#ccc" }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </Row>
            </Block>
          </>
        )}
      </Content>
    </>
  );
};

export default Dashboard;
